export default "__VITE_ASSET__bSGFHpuE__"